var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"classBnaer"},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","font-size":"20px"}},[_vm._v(" 暂无考试！ ")])])])
}]

export { render, staticRenderFns }